import { InjectionToken } from '@angular/core';

export const EUROGARD_TABLE_ROW_ACTION_METHOD = new InjectionToken(
  'eurogard-table-row-action-method',
);
